import Decimal from "decimal.js-light";
import numeral from 'numeral';
import {getAddress, isAddress} from "viem";

export const formatSignificantDigits = (value, significantDigits = 6, rounding = 1) => {
    return new Decimal(value || 0).toSignificantDigits(significantDigits, rounding).toFixed();
};

export const displayNumber = (num, significantDigits = 9) => {
    const _num = Number(num);
    if (_num >= 2**53) {
        return '∞'
    } else if (_num > 10000) {
        return numeral(num).format('0,0');
    } else if (_num > 10) {
        return numeral(num).format('0,0.00');
    } else {
        return formatSignificantDigits(num, significantDigits);
    }
}

// Shortens an Ethereum address
export function shortenAddress(address = '', charsStart = 4, charsEnd = 4) {
    return isAddress(address) ? ellipseAddressAdd0x(getAddress(address), charsStart, charsEnd) : '';
}

// Shortens an Ethereum TX hash
export function shortenHash(hash = '', charsStart = 4, charsEnd = 4) {
    return hash ? ellipseAddressAdd0x(hash, charsStart, charsEnd) : '';
}

function ellipseAddressAdd0x(targetAddress, charsStart = 4, charsEnd = 4) {
    const hasPrefix = targetAddress.startsWith('0x');
    const prefix = hasPrefix ? '' : '0x';
    return ellipseMiddle(prefix + targetAddress, charsStart + 2, charsEnd);
}

function ellipseMiddle(target, charsStart = 4, charsEnd = 4) {
    return `${target.slice(0, charsStart)}...${target.slice(target.length - charsEnd)}`;
}